export default __webpack_public_path__ + "static/media/dg-img.a6f86306.png";